import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ImportacionPlantillaModel } from 'app/modules/staff-count/entities/importacion-plantilla-model';
import { StaffImportViewService } from 'app/modules/staff-count/services/staff-import-view.service';
import { StaffImportService } from 'app/modules/staff-count/services/staff-import.service';

@Component({
    selector: 'app-formato-modal',
    templateUrl: './formato-modal.component.html',
    styleUrls: ['./formato-modal.component.scss'],
    standalone: false
})
export class FormatoModalComponent implements OnInit {

  importTemplates : ImportacionPlantillaModel[] =[];
  selectedImportTemplate: ImportacionPlantillaModel;
  selectedColumns: any;
  nombre = new UntypedFormControl();
  invalid = false;

  constructor(public dialogRef: MatDialogRef<FormatoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public sharedService: SharedService, 
    public staffImportService: StaffImportService, 
    public staffImportViewService: StaffImportViewService,   
    public dialog: MatDialog) {
      this.importTemplates = data.importTemplates;
      this.selectedImportTemplate = data.selectedImportTemplates
      this.selectedColumns = data.selectedColumns
  }

  ngOnInit(): void {
  }

  saveFormato(){
    const formatName: string = this.nombre.value? this.nombre.value.trim(): "";
    this.nombre.setValue(formatName);  
    if(formatName == ""){
      this.invalid = true;
      return;
    }

    if(this.importTemplates && this.importTemplates.length>0){
      var importFormat = this.importTemplates.find(x=>x.nombre && x.nombre.toLocaleLowerCase() == formatName.toLocaleLowerCase());
      if(importFormat){
        const dialogData = new ConfirmDialogModel('Este formato ya existe. ¿Deseas modificarlo?', "");
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          data: dialogData
        });
        dialogRef.afterClosed().subscribe(responce => {
          if (responce) {
            importFormat.nombre = formatName;
            importFormat.primeraFila = this.selectedImportTemplate? this.selectedImportTemplate.primeraFila : importFormat.primeraFila;
            importFormat.columnaClave = this.selectedImportTemplate? this.selectedImportTemplate.columnaClave : importFormat.columnaClave;
            importFormat.hojas = this.selectedImportTemplate? this.selectedImportTemplate.hojas : importFormat.hojas;
            importFormat.tipoImportacion = this.selectedImportTemplate? this.selectedImportTemplate.tipoImportacion : importFormat.tipoImportacion;
            importFormat.camposImportacion = this.selectedColumns;
            this.saveExcelImportTemplate(importFormat);
          }
        });
      }else{
        const model = new ImportacionPlantillaModel();
        model.nombre = formatName;
        model.primeraFila = this.selectedImportTemplate.primeraFila;
        model.columnaClave = this.selectedImportTemplate.columnaClave;
        model.hojas = this.selectedImportTemplate.hojas;
        model.tipoImportacion = this.selectedImportTemplate.tipoImportacion;
        model.camposImportacion = this.selectedColumns;
        this.saveExcelImportTemplate(model);
      }
    }

  }

  public saveExcelImportTemplate(model: any){
    this.staffImportService.saveExcelImportTemplate(model)
    .subscribe(res => {   
      if (res.code === 0) {
        this.sharedService.ShowSnackBar('¡Guardado correctamente!', 'Okay', 2000);
        this.staffImportViewService.isSaveExcelImportTemplate.emit({status: true, id: res.result});
      } else {
        this.sharedService.ShowSnackBar('¡Se ha producido un error al guardar!');
      }
      this.cancel();
    }, err => {
      this.sharedService.ShowSnackBar('¡Se ha producido un error al guardar!');
      console.error(err);
    });
  }

  cancel(){
    this.dialogRef.close();
  }
}
